/* TODO:
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

'use strict';

module.exports = {
  omitUndefined(obj) {
    const filteredObj = {};
    for (const key in obj) {
      const value = obj[key];
      if (value != null) {
        filteredObj[key] = value;
      }
    }
    return filteredObj;
  },

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
  },

  deQuotify(str) {
    if (str == null) {
      return null;
    }
    return str.replace(/&quot;/g, '"');
  },

  getDecodedParam(param) {
    if (!param) {
      return null;
    }
    try {
      return decodeURIComponent(param);
    } catch (error) {
      return null;
    }
  },

  isEmpty(object) {
    // TODO: confirm behvaior
    for (const key in object) {
      if (object.hasOwnProperty(key)) return false;
    }
    return true;
  },
};
